(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-full-width"]) return;
  try {
    
function initLowcatCalculators() {
  document.querySelectorAll('[data-lowcat-calculator]').forEach(function(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var feet = root.querySelector('.lowcat-total-feet');
    var spacing = root.querySelector('.lowcat-spacing');
    var rows = root.querySelector('.lowcat-rows');
    var result = root.querySelector('.lowcat-hoop-result');
    var message = root.querySelector('.lowcat-hoop-calculator__message');
    var recommendation = root.querySelector('.lowcat-hoop-calculator__recommendation');
    var recommendationLink = root.querySelector('.lowcat-hoop-calculator__recommendation-link');
    var overflow = root.querySelector('.lowcat-hoop-calculator__overflow');
    var kitData = root.querySelector('.lowcat-hoop-calculator__kit-data');

    function setRecommendation(hoops) {
      var size = 5;
      var quantity = 1;

      if (hoops <= 5) {
        size = 5;
      } else if (hoops <= 11) {
        size = 11;
      } else if (hoops <= 22) {
        size = 22;
      } else if (hoops < 220) {
        size = 22;
        quantity = Math.ceil(hoops / 22);
      } else if (hoops <= 220) {
        size = 220;
      } else if (hoops < 660) {
        size = 220;
        quantity = Math.ceil(hoops / 220);
      } else if (hoops <= 660) {
        size = 660;
      } else {
        size = 660;
        quantity = Math.ceil(hoops / 660);
      }

      var name = kitData.getAttribute('data-kit-' + size + '-name');
      var url = kitData.getAttribute('data-kit-' + size + '-url');
      var displayName = name || (size + ' Hoop Kit');

      if (quantity > 1) {
        displayName = quantity + ' × ' + displayName.replace(/ Kit$/, ' Kits');
      }

      recommendationLink.textContent = displayName;
      recommendationLink.href = url || '#';
      recommendation.hidden = false;
      overflow.hidden = true;
    }

    function calculate() {
      var feetValue = parseFloat(feet.value);
      var spacingValue = parseFloat(spacing.value);
      var rowsValue = parseInt(rows.value, 10);

      if (!(feetValue > 0) || !(spacingValue > 0) || !(rowsValue > 0)) {
        result.textContent = '—';
        message.textContent = message.dataset.incomplete;
        recommendation.hidden = true;
        overflow.hidden = true;
        return;
      }

      var hoops = Math.ceil((feetValue / spacingValue) + rowsValue);
      result.textContent = hoops.toLocaleString();
      message.textContent = message.dataset.formula;
      setRecommendation(hoops);
    }

    [feet, spacing, rows].forEach(function(input) {
      input.addEventListener('input', calculate);
    });

    calculate();
  });
}

initLowcatCalculators();
document.addEventListener('shopify:section:load', initLowcatCalculators);

  } catch(e) { console.error(e); }
})();
})();
